module.exports = __webpack_public_path__ + "media/Dotkit-UpdateKeys.67f59280.mp4";